module.exports = __webpack_public_path__ + "img/sensor-online.96fd4463.png";